import React from "react";
import { HeaderMenu } from "../components/Header";
import img_main from "../asset/img_main.png";
import img_simLogo from "../asset/simbridge_logo.png";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { Typography } from "../components/Typography";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "100vh",
      minWidth: "auto",
    },
  },
  body: {
    width: "100%",
    maxHeight: 1114,
    minHeight: 680,
    height: "100%",
    alignSelf: "center",
    background: "#fdf5fd",
    textAlign: "center",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    marginBottom: 35,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "12px 0px",
    },
  },
  imgBox: {
    position: "relative",
    alignSelf: "center",
    marginBottom: "116px",
    marginTop: "40px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginBottom: "20px",
    },
  },
  mainimage: {
    position: "relative",
    float: "right",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      left: 0,
    },
  },
  simLogo: {
    position: "relative",
    top: -95,
    left: 535,
    width: 96,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      top: -58,
      left: 315,
      width: 48,
    },
  },

  maintext: {
    display: "block",
    color: "#EB4FE5",
    position: "relative",
    fontSize: 70,
    alignSelf: "center",
    zIndex: 10,
    bottom: 120,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginTop: "20px",
      top: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      fontSize: 30,
    },
  },
  mainsubtext: {
    position: "relative",
    display: "block",
    width: 590,
    top: 420,
    left: 155,
    color: "#000",
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginTop: 25,
      top: 0,
      left: 0,
      textAlign: "center",
    },
  },
  container: {
    display: "flex",
    width: "1440px",
    height: "100%",
    position: "relative",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
    },
  },
  footerCon: {
    marginTop: 50,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      marginTop: 0,
    },
  },
}));

const Home = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.container}>
          <div className={classes.maintext}>
            <Typography variant="H1">Human Bridge</Typography>
          </div>
          <div className={classes.imgBox}>
            <img src={img_main} alt="main" className={classes.mainimage} />
            <img src={img_simLogo} alt="main" className={classes.simLogo} />
          </div>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default Home;
